import axios from 'axios';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';
import { MenuComponent } from '../../../_mexablock/assets/ts/components';
import * as auth from './redux/AuthRedux';

export function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    const splashScreen = document.getElementById('splash-screen');
    if (splashScreen) {
      splashScreen.style.setProperty('display', 'flex');
    }

    const userLogout = async () => {
      const API_URL = process.env.REACT_APP_API;
      await axios
        .post(`${API_URL}logout`)
        .then((res) => {
          dispatch(auth.actions.logout());

          // Limpiar sessionStorage
          sessionStorage.removeItem('selectedZonaId');
          sessionStorage.removeItem('zonaData');
          sessionStorage.removeItem('simasignadas');

          if (splashScreen) {
            splashScreen.style.setProperty('display', 'none');
          }
          // Reinicializar MenuComponent después del logout
          setTimeout(() => {
            MenuComponent.bootstrap();
          }, 200);
        })
        .catch((err) => {});
    };
    userLogout();
  }, [dispatch]);

  return <Switch>{/* <Redirect to='/auth/login' /> */}</Switch>;
}
